import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import ReproCheck from "./reproCheck/ReproCheck";
import { useReproducibilityContext } from "./Reproducibility";
const ReproChangesTab = () => {
    const { reproCheckFailedCount } = useReproducibilityContext();
    return (React.createElement(ErrorBoundary, { key: "repro-check" },
        React.createElement(ReproCheck, { failedCount: reproCheckFailedCount })));
};
export default ReproChangesTab;
//# sourceMappingURL=ReproChangesTab.js.map